module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-ar-SA.9349687d.jpg";